module.exports = __webpack_public_path__ + "static/media/br-mt.a80d503b.svg";